export default __webpack_public_path__ + "static/media/login3.9c68eb4d.svg";